<template>
	<div>
        <div class="flex">
            <div class="py-6 px-3 flex flex-col" :class="building.units.length ? 'w-1/2' : 'w-full'">
                <table v-if="building.units.length" class="w-full">
                    <thead class="cursor-pointer">
                        <tr>
                            <th class="text-center">Floor</th>
                            <th class="text-center">Suite</th>
                            <th class="text-right">Size</th>
                            <th class="text-right">Status</th>
                            <th class="text-right">Last Update</th>
                            <th v-if="$gate.isAdmin()"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="unit in building.units" :key="unit.id" :class="{ 'highlighted': highlightedUnit && unit.id == highlightedUnit.id }">
                            <td class="text-center">{{ unit.floor }}</td>
                            <td class="text-center">{{ unit.suite }}</td>
                            <td class="text-right">{{ unit.size | number }}</td>
                            <td class="text-right">{{ unit.status }}</td>
                            <td class="text-right">{{ unit.updated_at | date }}</td>
                            <td v-if="$gate.isAdmin()" class="text-right">
                                <div class="flex justify-end space-x-3">
                                    <button @click="showEditUnit(unit.id)" type="button" class="btn-action">Edit</button>
                                    <button @click="confirmDeleteUnit(unit.id)" type="button" class="ml-3 btn-action">Delete</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="mt-8 flex flex-col h-full items-center justify-center space-y-2">
                    <span class="text-xl">No Units Found</span>
                    <button 
                        type="button"
                        @click.prevent="showManageUnits"
                        class="flex items-center btn btn-small btn-indigo">
                            <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                            <span class="ml-2">Create Unit</span>
                    </button>
                </div>

                <button v-if="building.units.length" @click.prevent="showManageUnits" class="mt-3 self-end flex items-center btn btn-small btn-indigo">
                    <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                    <span class="ml-2">Create Unit</span>
                </button>
            </div>

            <div v-if="building.units.length" class="p-6 w-1/2">
                <stack-chart
                    :data="building.stack"
                    @unitSelected="highlightUnit"
                    @unitdeSelected="highlightedUnit = {}">
                </stack-chart>
            </div>
        </div>

        <modal name="manage-units" width="50%" height="auto" draggable=".modal-header">
            <manage-units></manage-units>
        </modal>

        <notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
    	props: {
            buildingData: {
                type: Object,
                required: true
            },
        },
        
    	data() {
    		return {
                building: this.buildingData,

                selectedUnit: '',
                highlightedUnit: {}
    		}
    	},

        mounted() {
            this.units.all = this.building.units;
            this.units.filtered = this.building.units;
        },

        computed: {
            ...mapState(['units']),
        },

        methods: {
            highlightUnit(e) {
                this.highlightedUnit = _.find(this.building.units, (unit) => {
                    return unit.floor == e.categoryLabel && unit.size == e.dataValue;
                });
            },

            sort() {
                this.building.units = _.sortBy(this.building.units, ['floor', 'suite', 'size']);
            },

            showManageUnits() {
                this.selectedUnit = "";

                this.$modal.show('manage-units');
            },

            showEditUnit(unitId) {
                this.selectedUnit = unitId;

                this.$modal.show('edit-unit');
            },

            saveUnit(data) {
                this.building = data.building;

                this.sort();
            },

            removeUnit(unitId) {
                var unit = _.find(this.building.units, (unit) => {
                    return unit.id == unitId;
                });

                if (! unit) {
                    return;
                }

                var stackSize = this.building.stack[unit.floor][unit.status];

                // remove the unit
                this.building.units = _.remove(this.building.units, (unit) => { return unit.id != unitId });

                // update the stack chart
                this.building.stack[unit.floor][unit.status] = stackSize - unit.size;
            },

            confirmDeleteUnit(unitId) {
                this.$swal({
                    title: 'Delete this unit?',
                    text: "ALL data will be lost, including any lease information attached to this unit",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteUnit(unitId);
                    }
                });
            },

            deleteUnit(unitId) {
                axios.delete('/units/' + unitId)
                    .then((response) => {
                        this.removeUnit(unitId);

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch((error) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },
        }
    }
</script>